import React, {useEffect, useState} from 'react';
import {
    createService,
    deleteService,
    getServices,
    getSnapcodes,
    sendNotification,
    updateService,
    updateSnapcode,
    uploadImage
} from '../utils/api';
import './styles/AdminDashboard.css';
import IconSelect from './IconSelect';

const ionicons = ["accessibility","add","add-circle","airplane","alarm","albums","alert","alert-circle","american-football","analytics","aperture","apps","archive","arrow-back","arrow-back-circle","arrow-down","arrow-down-circle","arrow-forward","arrow-forward-circle","arrow-redo","arrow-redo-circle","arrow-undo","arrow-undo-circle","arrow-up","arrow-up-circle","at","at-circle","attach","backspace","bag","bag-add","bag-check","bag-handle","bag-remove","balloon","ban","bandage","bar-chart","barbell","barcode","baseball","basket","basketball","battery-charging","battery-dead","battery-full","battery-half","beaker","bed","beer","bicycle","bluetooth","boat","body","bonfire","book","bookmark","bookmarks","bowling-ball","briefcase","browsers","brush","bug","build","bulb","bus","business","cafe","calculator","calendar","calendar-clear","calendar-number","call","camera","camera-reverse","car","car-sport","card","caret-back","caret-back-circle","caret-down","caret-down-circle","caret-forward","caret-forward-circle","caret-up","caret-up-circle","cart","cash","cellular","chatbox","chatbox-ellipses","chatbubble","chatbubble-ellipses","chatbubbles","checkbox","checkmark","checkmark-circle","checkmark-done","checkmark-done-circle","chevron-back","chevron-back-circle","chevron-collapse","chevron-down","chevron-down-circle","chevron-expand","chevron-forward","chevron-forward-circle","chevron-up","chevron-up-circle","clipboard","close","close-circle","cloud","cloud-circle","cloud-done","cloud-download","cloud-offline","cloud-upload","cloudy","cloudy-night","code","code-download","code-slash","code-working","cog","color-fill","color-filter","color-palette","color-wand","compass","construct","contract","contrast","copy","create","crop","cube","cut","desktop","diamond","dice","disc","document","document-attach","document-lock","document-text","documents","download","duplicate","ear","earth","easel","egg","ellipse","ellipsis-horizontal","ellipsis-horizontal-circle","ellipsis-vertical","ellipsis-vertical-circle","enter","exit","expand","extension-puzzle","eye","eye-off","eyedrop","fast-food","female","file-tray","file-tray-full","file-tray-stacked","film","filter","filter-circle","finger-print","fish","fitness","flag","flame","flash","flash-off","flashlight","flask","flower","folder","folder-open","football","footsteps","funnel","game-controller","gift","git-branch","git-commit","git-compare","git-merge","git-network","git-pull-request","glasses","globe","golf","grid","hammer","hand-left","hand-right","happy","hardware-chip","headset","heart","heart-circle","heart-dislike","heart-dislike-circle","heart-half","help","help-buoy","help-circle","home","hourglass","ice-cream","id-card","image","images","infinite","information","information-circle","invert-mode","journal","key","keypad","language","laptop","layers","leaf","library","link","list","list-circle","locate","location","lock-closed","lock-open","log-in","log-out","magnet","mail","mail-open","mail-unread","male","male-female","man","map","medal","medical","medkit","megaphone","menu","mic","mic-circle","mic-off","mic-off-circle","moon","move","musical-note","musical-notes","navigate","navigate-circle","newspaper","notifications","notifications-circle","notifications-off","notifications-off-circle","nuclear","nutrition","open","options","paper-plane","partly-sunny","pause","pause-circle","paw","pencil","people","people-circle","person","person-add","person-circle","person-remove","phone-landscape","phone-portrait","pie-chart","pin","pint","pizza","planet","play","play-back","play-back-circle","play-circle","play-forward","play-forward-circle","play-skip-back","play-skip-back-circle","play-skip-forward","play-skip-forward-circle","podium","power","pricetag","pricetags","print","prism","pulse","push","qr-code","radio","radio-button-off","radio-button-on","rainy","reader","receipt","recording","refresh","refresh-circle","reload","reload-circle","remove","remove-circle","reorder-four","reorder-three","reorder-two","repeat","resize","restaurant","return-down-back","return-down-forward","return-up-back","return-up-forward","ribbon","rocket","rose","sad","save","scale","scan","scan-circle","school","search","search-circle","send","server","settings","shapes","share","share-social","shield","shield-checkmark","shield-half","shirt","shuffle","skull","snow","sparkles","speedometer","square","star","star-half","stats-chart","stop","stop-circle","stopwatch","storefront","subway","sunny","swap-horizontal","swap-vertical","sync","sync-circle","tablet-landscape","tablet-portrait","telescope","tennisball","terminal","text","thermometer","thumbs-down","thumbs-up","thunderstorm","ticket","time","timer","today","toggle","trail-sign","train","transgender","trash","trash-bin","trending-down","trending-up","triangle","trophy","tv","umbrella","unlink","videocam","videocam-off","volume-high","volume-low","volume-medium","volume-mute","volume-off","walk","wallet","warning","watch","water","wifi","wine","woman"];

const AdminDashboard = () => {
    const [services, setServices] = useState([]);
    const [newService, setNewService] = useState({ name: '', description: '', icon: '', profileUrl: '' });
    const [editService, setEditService] = useState(null);
    const [notification, setNotification] = useState({ title: '', body: '' });
    const [snapcodes, setSnapcodes] = useState([]);
    const [editSnapcode, setEditSnapcode] = useState(null);
    const [selectedIcon, setSelectedIcon] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [serviceBackgroundImage, setServiceBackgroundImage] = useState(null);

    const [showAddService, setShowAddService] = useState(false);
    const [showEditServices, setShowEditServices] = useState(false);
    const [showSendNotification, setShowSendNotification] = useState(false);
    const [showModifySnapcodes, setShowModifySnapcodes] = useState(false);

    useEffect(() => {
        const fetchServices = async () => {
            const servicesData = await getServices();
            setServices(servicesData);
        };

        const fetchSnapcodes = async () => {
            const snapcodesData = await getSnapcodes();
            setSnapcodes(snapcodesData);
        };

        fetchServices();
        fetchSnapcodes();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewService({ ...newService, [name]: value });
        if (name === 'icon') {
            setSelectedIcon(value);
        }
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditService({ ...editService, [name]: value });
        if (name === 'icon') {
            setSelectedIcon(value);
        }
    };

    const handleNotificationChange = (e) => {
        setNotification({ ...notification, [e.target.name]: e.target.value });
    };

    const handleSnapcodeChange = (e) => {
        setEditSnapcode({ ...editSnapcode, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        setImageFile(e.target.files[0]);
    };

    const handleBackgroundImageChange = (e) => {
        setServiceBackgroundImage(e.target.files[0]);
    };

    const handleUploadImage = async (file) => {
        try {
            return await uploadImage(file);
        } catch (error) {
            console.error('Erreur lors de l\'upload de l\'image:', error);
        }
    };

    const handleCreate = async () => {
        let backgroundImageUrl = '';
        if (serviceBackgroundImage) {
            backgroundImageUrl = await handleUploadImage(serviceBackgroundImage);
        }
        const newServiceWithOutline = { ...newService, icon: selectedIcon ? `${selectedIcon}-outline` : '', backgroundImage: backgroundImageUrl };
        const createdService = await createService(newServiceWithOutline);
        setServices([...services, createdService]);
        setNewService({ name: '', description: '', icon: '', profileUrl: '' });
        setSelectedIcon('');
        setServiceBackgroundImage(null);
    };

    const handleUpdate = async () => {
        let updatedBackgroundImageUrl = editService.backgroundImage;
        if (serviceBackgroundImage) {
            updatedBackgroundImageUrl = await handleUploadImage(serviceBackgroundImage);
        }
        const editServiceWithOutline = { ...editService, icon: selectedIcon ? `${selectedIcon}-outline` : '', backgroundImage: updatedBackgroundImageUrl };
        const updated = await updateService(editService._id, editServiceWithOutline);
        setServices(services.map(service => service._id === editService._id ? updated : service));
        setEditService(null);
        setSelectedIcon('');
        setServiceBackgroundImage(null);
    };

    const handleDelete = async (id) => {
        await deleteService(id);
        setServices(services.filter(service => service._id !== id));
    };

    const handleSendNotification = async () => {
        const response = await sendNotification(notification);
        alert(`Notifications envoyées: ${response.successes} succès, ${response.failures} échecs`);
        setNotification({ title: '', body: '' });
    };

    const handleUpdateSnapcode = async () => {
        let updatedSnapcode = editSnapcode;

        if (imageFile) {
            const imageUrl = await handleUploadImage(imageFile);
            updatedSnapcode = { ...editSnapcode, imageUrl };
        }

        const updated = await updateSnapcode(editSnapcode._id, updatedSnapcode);
        setSnapcodes(snapcodes.map(snapcode => snapcode._id === editSnapcode._id ? updated : snapcode));
        setEditSnapcode(null);
        setImageFile(null);
    };

    return (
        <div className="admin-dashboard">
            <h1>Tableau de Bord</h1>

            <div className="section">
                <button onClick={() => setShowAddService(!showAddService)}>
                    Ajouter un Nouveau Service
                </button>
                {showAddService && (
                    <div className="service-form">
                        <input name="name" value={newService.name} onChange={handleChange} placeholder="Nom" />
                        <input name="description" value={newService.description} onChange={handleChange} placeholder="Description" />
                        <IconSelect
                            value={selectedIcon}
                            onChange={handleChange}
                            options={ionicons}
                        />
                        <input name="profileUrl" value={newService.profileUrl} onChange={handleChange} placeholder="URL du Profil" />
                        <input type="file" onChange={handleBackgroundImageChange} />
                        <button onClick={handleCreate}>Créer le Service</button>
                    </div>
                )}
            </div>

            <div className="section">
                <button onClick={() => setShowEditServices(!showEditServices)}>
                    Modifier les Services Existants
                </button>
                {showEditServices && (
                    <>
                        <ul className="service-list">
                            {services.map(service => (
                                <li key={service._id} className="service-item">
                                    <div className="service-details">
                                        <p><strong>Nom:</strong> {service.name}</p>
                                        <p><strong>Description:</strong> {service.description}</p>
                                    </div>
                                    <div className="service-actions">
                                        <button onClick={() => {
                                            setEditService(service);
                                            setSelectedIcon(service.icon.replace('-outline', '') || '');
                                            setServiceBackgroundImage(null);
                                        }}>Modifier</button>
                                        <button onClick={() => handleDelete(service._id)}>Supprimer</button>
                                    </div>
                                </li>
                            ))}
                        </ul>

                        {editService && (
                            <div className="service-form">
                                <h2>Modifier le Service</h2>
                                <input name="name" value={editService.name} onChange={handleEditChange} placeholder="Nom" />
                                <input name="description" value={editService.description} onChange={handleEditChange} placeholder="Description" />
                                <IconSelect
                                    value={selectedIcon}
                                    onChange={handleEditChange}
                                    options={ionicons}
                                />
                                <input name="profileUrl" value={editService.profileUrl} onChange={handleEditChange} placeholder="URL du Profil" />
                                <input type="file" onChange={handleBackgroundImageChange} />
                                <button onClick={handleUpdate}>Enregistrer les Modifications</button>
                                <button onClick={() => setEditService(null)}>Annuler</button>
                            </div>
                        )}
                    </>
                )}
            </div>

            <div className="section">
                <button onClick={() => setShowModifySnapcodes(!showModifySnapcodes)}>
                    Modifier les Snapcodes
                </button>
                {showModifySnapcodes && (
                    <>
                        <ul className="snapcode-list">
                            {snapcodes.map(snapcode => (
                                <li key={snapcode._id} className="snapcode-item">
                                    <div className="snapcode-details">
                                        <p><strong>Titre:</strong> {snapcode.title}</p>
                                        <p><strong>URL du Profil:</strong> {snapcode.profileUrl}</p>
                                        <button onClick={() => setEditSnapcode(snapcode)}>Modifier</button>
                                    </div>
                                </li>
                            ))}
                        </ul>

                        {editSnapcode && (
                            <div className="snapcode-form">
                                <h2>Modifier le Snapcode</h2>
                                <input name="title" value={editSnapcode.title} onChange={handleSnapcodeChange} placeholder="Titre" />
                                <input name="profileUrl" value={editSnapcode.profileUrl} onChange={handleSnapcodeChange} placeholder="URL du Profil" />
                                <input name="imageUrl" value={editSnapcode.imageUrl} onChange={handleSnapcodeChange} placeholder="URL de l'Image" />
                                <input type="file" onChange={handleFileChange} />
                                <button onClick={handleUpdateSnapcode}>Enregistrer les Modifications</button>
                                <button onClick={() => setEditSnapcode(null)}>Annuler</button>
                            </div>
                        )}
                    </>
                )}
            </div>

            <div className="section">
                <button onClick={() => setShowSendNotification(!showSendNotification)}>
                    Envoyer des Notifications
                </button>
                {showSendNotification && (
                    <div className="notification-form">
                        <input name="title" value={notification.title} onChange={handleNotificationChange} placeholder="Titre" />
                        <textarea name="body" value={notification.body} onChange={handleNotificationChange} placeholder="Contenu" />
                        <button onClick={handleSendNotification}>Envoyer la Notification</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminDashboard;